import { connect } from 'react-redux';
import MyStoreReviewCustomer from '../components/MyStore/MyStoreReviewCustomer';

const mapStateToProps = function(store) {
    // from template
    return {
        customerID: window.customerID,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {};
};
const MyStoreReviewCustomerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyStoreReviewCustomer);

export default MyStoreReviewCustomerContainer;
